import { useState } from 'react'

import { meetingApi } from '../api'
import { RequestAssistNowRequest } from '../api/meetingApiInterfaces'

const useAssistNow = () => {
  const [isRequesting, setIsRequesting] = useState(false)

  const requestAssistNow = async (meetingId: string, payload?: RequestAssistNowRequest) => {
    setIsRequesting(true)
    try {
      return await meetingApi.requestAssistNow(meetingId, payload)
    } catch (error) {
      console.error('Failed to request assist now', error)
    } finally {
      setIsRequesting(false)
    }
  }

  return { isRequesting, requestAssistNow }
}

export default useAssistNow
